<template>
  <div class="vue-simplemde">
    <textarea :name="name"></textarea>
  </div>
</template>

<script>
import SimpleMDE from "simplemde";
import marked from "marked";

export { marked };

export default {
  name: "vue-simplemde",
  props: {
    value: String,
    name: String,
    previewClass: String,
    autoinit: {
      type: Boolean,
      default() {
        return true;
      }
    },
    highlight: {
      type: Boolean,
      default() {
        return false;
      }
    },
    sanitize: {
      type: Boolean,
      default() {
        return false;
      }
    },
    configs: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default: ""
    }
  },
  mounted() {
    if (this.autoinit) this.initialize();
  },
  activated() {
    const editor = this.simplemde;
    if (!editor) return;
    const isActive = editor.isSideBySideActive() || editor.isPreviewActive();
    if (isActive) editor.toggleFullScreen();
  },
  methods: {
    initialize() {
      const configs = Object.assign(
        {
          element: this.$el.firstElementChild,
          initialValue: this.value,
          renderingConfig: {}
        },
        this.configs
      );

      if (configs.initialValue) {
        this.$emit("input", configs.initialValue);
      }

      if (this.highlight) {
        configs.renderingConfig.codeSyntaxHighlighting = true;
      }

      marked.setOptions({ sanitize: this.sanitize });

      this.simplemde = new SimpleMDE(configs);

      const className = this.previewClass || "";
      this.addPreviewClass(className);

      this.bindingEvents();
      if (this.title) {
        let t = document.createElement("i");
        t.classList.add("separator");
        t.innerText = "|";
        this.$el
          .getElementsByClassName("editor-toolbar")[0]
          .insertAdjacentElement("afterbegin", t);
        t = document.createElement("span");
        t.classList.add("field-title");
        t.innerText = this.title;
        this.$el
          .getElementsByClassName("editor-toolbar")[0]
          .insertAdjacentElement("afterbegin", t);
      }
    },
    bindingEvents() {
      this.simplemde.codemirror.on("change", () => {
        this.$emit("input", this.simplemde.value());
      });
    },
    addPreviewClass(className) {
      const wrapper = this.simplemde.codemirror.getWrapperElement();
      const preview = document.createElement("div");
      wrapper.nextSibling.className += ` ${className}`;
      preview.className = `editor-preview ${className}`;
      wrapper.appendChild(preview);
    }
  },
  destroyed() {
    this.simplemde = null;
  },
  watch: {
    value(val) {
      if (val === this.simplemde.value()) return;
      this.simplemde.value(val);
    }
  }
};
</script>

<style>
@import "style.scss";

.vue-simplemde .markdown-body {
  padding: 0.5em;
}

.vue-simplemde .editor-preview-active,
.vue-simplemde .editor-preview-active-side {
  display: block;
}
</style>
